// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-all-js": () => import("./../src/pages/all.js" /* webpackChunkName: "component---src-pages-all-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-stats-js": () => import("./../src/pages/stats.js" /* webpackChunkName: "component---src-pages-stats-js" */)
}

